import React from 'react';
import styled from 'styled-components';
import { Grid, Typography } from '@material-ui/core';
import { breakpoint } from 'utils/mediaQueries';
import { colors } from 'styles';

const ContentText = styled(Grid)`
  width: 100%;
  ${breakpoint.down('md')`
  text-align:center; justify-content:center`};
`;
const Subtitle = styled(Typography)`
  ${breakpoint.down('md')`
  font-size: ${props => `${props.theme.typography.h5.fontSize}
px`};`};
  ${breakpoint.down('sm')`
    font-size: ${props => `${props.theme.typography.h6.fontSize}px`}`};
  ${breakpoint.only('xxs')`
  font-size: ${props => `${props.theme.typography.body1.fontSize}px`};
  `};
  span {
    color: ${colors.purple};
  }
`;
const BlockText = ({ markdownContent }) => {
  return (
    <ContentText
      container
      item
      xs={12}
      sm={12}
      md={9}
      lg={10}
      alignItems="center"
      justify="flex-start"
    >
      <Subtitle
        variant="h1"
        dangerouslySetInnerHTML={{
          __html: markdownContent.rawMarkdownBody,
        }}
      />
    </ContentText>
  );
};
export default BlockText;
